import React, {useState} from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';




const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
      marginTop: '120px'
    },
    gridBlock: {
        display:'block'
    },
    avatar: {
        margin: '55px auto 55px auto',
        width: theme.spacing(20),
        height: theme.spacing(20),
    },
    avatarblock:{
        display:'inline-block',
        '& h4': {
          paddingTop:'25px'
        }
    },
    nameFiled: {
        width: '25ch',
        marginBottom: '5ch'
    },
    margin: {
        margin: theme.spacing(5),
    },
    bottomText: {
        marginBottom: '3ch'
    },
  }));

  const BorderLinearProgress = withStyles({
    root: {
      height: 20,
    },
    bar: {
      borderRadius: 20,
    },
  })(LinearProgress);


export default function Completion() {
    const classes = useStyles();
    const [completionValue] = useState(25);


    return (
        <div className={classes.root}>
            <CssBaseline />
            <Grid className={classes.gridBlock} container spacing={3}>
                <div className={classes.avatarblock}>
                    <Typography variant="h4" gutterBottom>
                        Congratulations, you just gained 25 Exp !
                    </Typography>
                    <Typography variant="h4" gutterBottom>
                        Enjoy your 7 day free trial !
                    </Typography>
                    <BorderLinearProgress 
                        className={classes.margin} 
                        variant="determinate" 
                        color="secondary"
                        value={completionValue} />  
                </div>
            </Grid>
        </div>
    )
}